import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { SubscribePage } from './subscribe';
import { SharedModule } from '../../../shared';
import { TranslateModule } from '@ngx-translate/core';
import { PriceCardComponent } from './components/price-card.component';
import { translateConfig } from '../../config/translate.config';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StripeFormComponent } from './components/stripe-form.component';
import { TemporaryMalfunctionPage } from './components/temporary-malfunction.component';

@NgModule({
  declarations: [
    SubscribePage,
    PriceCardComponent,
    StripeFormComponent,
    TemporaryMalfunctionPage
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule.forChild([{ path: '', component: SubscribePage }]),
    TranslateModule.forChild(translateConfig),
    SharedModule
  ]
})
export class SubscribePageModule {}
